import React from 'react';

import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const DeleteLocationModal = ({ locationName, open, onClose, onConfirm }) => {
  
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle><span className="roboto-regular">{t('deactivate_location', { defaultValue: 'Desactivar local' })}</span></DialogTitle>
      <DialogContent>
        <Typography>
          <span className="roboto-light">
            {t('deactivate_location_confirmation', {
              locationName,
              defaultValue: `¿Querés desactivar ${locationName}? Se conservará el histórico, se desvinculará el personal de ese local y no se podrá hacer si tiene cajas abiertas.`,
            })}
          </span>
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('cancel')}</Button>
        <Button onClick={onConfirm} variant="contained" color="primary">
          {t('deactivate', { defaultValue: 'Desactivar' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteLocationModal;
